import React from 'react';
import PropTypes from 'prop-types';

import Header from './header';
import SideNav from '../../Menu/SideNav';
import Footer from './Footer';
import {
  BodyWrapper,
  BodyContainer,
  MainContainer,
  MainContent,
} from './styles/LayoutStyled';

const Layout = ({ children, showNavbar }) => {
  return (
    <>
      <Header gradient />
      <BodyWrapper>
        <BodyContainer>
          <SideNav />
          <MainContainer>
            <MainContent>{children}</MainContent>
          </MainContainer>
        </BodyContainer>
      </BodyWrapper>
      <Footer gradient showNavbar={showNavbar} />
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  showNavbar: PropTypes.bool,
};

Layout.defaultProps = {
  showNavbar: false,
};

export default Layout;
